import { useEffect, useState } from "react";
import axios from "axios";
import { Appid, BaseUrl, Imei, LoginTypeID, SerialNo, Version } from "../../enum/enum";
import { useLoader } from "../../context/loaderContext";
import { useAuth } from "../../context/authContext";
import Layout from "../../layout/layout";
import moment from "moment";

const LedgerReport = () => {
    const { showLoader, hideLoader } = useLoader();
    const {
        token,
        sessionId,
        userId,
        mobile,
    } = useAuth();

    const [ledgerReport, setLedgerReport] = useState([]);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [remarkDetails, setRemarkDetails] = useState("");

    const getLedgerReport = async () => {
        try {
            const url = `${BaseUrl}App/LedgerReport`;

            const obj = {
                "appid": Appid,
                "imei": Imei,
                "loginTypeID": LoginTypeID,
                "regKey": "",
                "serialNo": SerialNo,
                "session": token,
                "sessionID": sessionId,
                "userID": userId,
                "version": Version,
                "FromDate": fromDate ? moment(fromDate).format("DD-MMM-YYYY") : moment(new Date(), "DD-MMM-YYYY").format("DD-MMM-YYYY"),
                "ToDate": toDate ? moment(toDate).format("DD-MMM-YYYY") : moment(new Date(), "DD-MMM-YYYY").format("DD-MMM-YYYY"),
                "WalletTypeID": 1,
                "accountNo": mobile,
                "isExport": false,
                "oid": "0",
                "status": "0",
                "topRows": "50",
                "isSeller": false,
            }

            showLoader();

            const res = await axios.post(url, obj);

            if (res.data?.statuscode == 1) {
                setLedgerReport(res.data.ledgerReport || []);
            } else {
                setLedgerReport([]);
            }

            hideLoader();
        } catch (e) {
            hideLoader();
            console.log(e.message);
        }
    }

    useEffect(() => {
        getLedgerReport();
    }, []);

    return (
        <Layout>
            <main>
                <div className="pageWrapper maxWidth pt-0">
                    <div className="container-fluid income-report-main">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="desktop-card card">
                                    <div className="card-header mb-3">
                                        <h5> Ledger Report </h5>
                                    </div>
                                    {/* filters */}
                                    {/* {ledgerReport?.length > 0 && ( */}
                                    <div className="mx-md-3 mx-0 table-filter"
                                        style={{
                                            display: 'grid',
                                            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                                            gap: '16px'
                                        }}
                                    >
                                        <div>
                                            <label className="form-label">From Date</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={fromDate || moment(new Date()).format(("YYYY-MM-DD"))}
                                                onChange={(e) => setFromDate(e.target.value)}
                                            />
                                        </div>
                                        <div>
                                            <label className="form-label">To Date</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={toDate || moment(new Date()).format(("YYYY-MM-DD"))}
                                                min={fromDate}
                                                onChange={(e) => setToDate(e.target.value)}
                                            />
                                        </div>
                                        {/* <div>
                                               <label className="form-label">From User</label>
                                               <input
                                                   type="text"
                                                   className="form-control"
                                                   placeholder="From User..."
                                                   value={fromUser}
                                                   onChange={(e) => setFromUser(e.target.value)}
                                               />
                                           </div> */}
                                        <div className="d-flex-end">
                                            <button
                                                type="button"
                                                onClick={getLedgerReport}
                                                className="cus-btn-submit"
                                            >Search</button>
                                        </div>
                                    </div>
                                    {/* // )} */}
                                    {/* records */}
                                    <div className="desktop-view-only card-body px-0">
                                        {
                                            ledgerReport?.length > 0 ? (
                                                <div className="table-responsive">
                                                    <table className="table align-middle mb-0 bg-hover-effect">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col">#</th>
                                                                <th scope="col">Txn Id</th>
                                                                <th scope="col">Tr Type</th>
                                                                <th scope="col">Opening</th>
                                                                <th scope="col">Tr Amount</th>
                                                                <th scope="col">Closing</th>
                                                                <th scope="col">Description</th>
                                                                <th scope="col">Date</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                ledgerReport?.map((el, i) => (
                                                                    <tr key={i}>
                                                                        <td>{i + 1}</td>
                                                                        <td>{el.tid}</td>
                                                                        <td>
                                                                            {
                                                                                el.credit ? <span class='badge bg-success'>Credit</span>
                                                                                    : <span class='badge bg-danger badge-default'>Debit</span>
                                                                            }
                                                                        </td>
                                                                        <td>${el.lastAmount}</td>
                                                                        <td>
                                                                            ${el.debit || el.credit}
                                                                        </td>
                                                                        <td>${el.curentBalance}</td>
                                                                        <td>
                                                                            {
                                                                                el.description?.length > 15 ? (

                                                                                    <div onClick={() => setRemarkDetails(el.description)} className="cursorPointer">
                                                                                        <i className="fa fa-info-circle" style={{ fontSize: "20px", color: "#334453" }}></i>
                                                                                    </div>
                                                                                ) : <span>{el.description}</span>
                                                                            }
                                                                        </td>
                                                                        <td>{el.entryDate}</td>
                                                                    </tr>
                                                                ))
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            ) : (
                                                <div>
                                                    <p className="text-center">No records found.</p>
                                                </div>
                                            )}
                                    </div>
                                    <div className="mobile-view-only mt-3">
                                        {ledgerReport?.length > 0 ? (
                                            ledgerReport.map((el, i) => (
                                                <div key={i} className="card mb-3 p-3 bg-hover-effect rounded shadow-sm">
                                                    <div className="d-flex justify-content-between align-items-center my-2">
                                                        <span className="badge bg-dark">#{i + 1}</span>
                                                        <span className="small">{el.entryDate}</span>
                                                    </div>
                                                    <div className="d-flex justify-content-between align-items-center my-1">
                                                        <strong>Txn Id:</strong>
                                                        <p className="mb-0 f-w-500">{el.tid}</p>
                                                    </div>
                                                    <div className="d-flex justify-content-between align-items-center my-1">
                                                        <strong>Tr Type:</strong>
                                                        <p className="mb-0 f-w-500">
                                                            {
                                                                el.credit ? <span class='badge bg-success'>Credit</span>
                                                                    : <span class='badge bg-danger badge-default'>Debit</span>
                                                            }
                                                        </p>
                                                    </div>
                                                    <div className="d-flex justify-content-between align-items-center my-1">
                                                        <strong>Opening:</strong>
                                                        <p className="mb-0 f-w-500">${el.lastAmount}</p>
                                                    </div>
                                                    <div className="d-flex justify-content-between align-items-center my-1">
                                                        <strong>Tr Amount:</strong>
                                                        <p className="mb-0 f-w-500">${el.debit || el.credit}</p>
                                                    </div>
                                                    <div className="d-flex justify-content-between align-items-center my-1">
                                                        <strong>Closing:</strong>
                                                        <p className="mb-0 f-w-500">${el.curentBalance}</p>
                                                    </div>
                                                    <div className="d-flex justify-content-between align-items-center my-1">
                                                        <strong>Description:</strong>
                                                        {
                                                            el.description?.length > 15 ? (

                                                                <div onClick={() => setRemarkDetails(el.description)} className="cursorPointer">
                                                                    <i className="fa fa-info-circle" style={{ fontSize: "20px", color: "#334453" }}></i>
                                                                </div>
                                                            ) : <span>{el.description}</span>
                                                        }
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <p className="text-center">No records found.</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {remarkDetails && (
                    <div
                        className="modal fade show"
                        style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
                    >
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title mt-0">Description</h5>
                                    <button
                                        type="button"
                                        className="btn-close text-light"
                                        onClick={() => { setRemarkDetails(""); }}
                                    ></button>
                                </div>
                                <div className="modal-body" style={{ wordBreak: "break-all" }}>
                                    {remarkDetails}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </main>
        </Layout >
    )
}

export default LedgerReport;